<template>
  <div>
    <div class="mw-announcement-active">
      <div class="mw-announcement-image" :style="bkgStyle(active.image)">
        <div
          style="
            overflow: hidden;
            height: 100%;
            z-index: 2;"
        ></div>
      </div>
      <div class="mw-announcement-content-container">
        <div class="mw-announcement-content">
          <h3>{{ active.title }}</h3>
          <div>
            <div
              class="html-content"
              v-html="active.content"
              style="-webkit-box-orient: vertical;"
            ></div>
            <a
              v-if="active.url && active.url.length"
              :href="active.url"
              class="content-link"
            >
              {{
                active.label && active.label.length
                  ? active.label
                  : "LEARN MORE"
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="mw-announcement-list">
      <button
        @click="updateActive(item, $event)"
        v-for="(item, index) in initialData"
        :style="bkgStyle(item.image)"
        :key="item.title.replace(' ', '-') + ' - ' + index"
      ></button>
    </div>
    <div class="announcement-mobile-controls">
      <button @click="prevActive()" type="button">
        <svg
          width="9"
          height="12"
          viewBox="0 0 9 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.68867 11.7919L0.748814 6.52927C0.628434 6.46439 0.559004 6.32907 0.574227 6.18902L4.15327 6.18902L4.24056 6.30244L8.16878 9.13792C8.29756 9.21959 8.39129 9.34949 8.43066 9.50086V11.4517C8.43066 11.928 8.05967 12.0641 7.68867 11.7919ZM7.66684 0.563469L0.748814 5.80344C0.61999 5.87117 0.549061 6.01862 0.574227 6.16638L4.13145 6.16638L4.21874 6.05296L8.14696 3.24016C8.27573 3.15849 8.36946 3.02859 8.40884 2.87722V0.926411C8.40884 0.450049 8.03784 0.291262 7.66684 0.563469Z"
            fill="white"
          />
        </svg>
      </button>
      <button @click="nextActive()" type="button">
        <svg
          width="9"
          height="12"
          viewBox="0 0 9 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.31133 11.7919L8.25119 6.52927C8.37157 6.46439 8.441 6.32907 8.42577 6.18902L4.84673 6.18902L4.75944 6.30244L0.831217 9.13792C0.702444 9.21959 0.608714 9.34949 0.569336 9.50086L0.569336 11.4517C0.569336 11.928 0.940334 12.0641 1.31133 11.7919ZM1.33316 0.563469L8.25119 5.80344C8.38001 5.87117 8.45094 6.01862 8.42577 6.16638L4.86855 6.16638L4.78126 6.05296L0.853041 3.24016C0.724268 3.15849 0.630538 3.02859 0.59116 2.87722L0.59116 0.926411C0.59116 0.450049 0.962158 0.291262 1.33316 0.563469Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialData: { type: Array },
  },
  data() {
    return {
      active: this.initialData[0],
      activeIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  updated() {},
  methods: {
    nextActive() {
      let nextIndex =
        this.activeIndex === this.initialData.length - 1
          ? 0
          : this.activeIndex + 1;
      this.activeIndex = nextIndex;
      this.active = this.initialData[nextIndex];
    },
    prevActive() {
      let nextIndex =
        this.activeIndex === 0
          ? this.initialData.length - 1
          : this.activeIndex - 1;
      this.activeIndex = nextIndex;
      this.active = this.initialData[nextIndex];
    },
    bkgStyle(image) {
      const toReturn = {
        backgroundImage: 'url("' + image + '")',
      };
      return toReturn;
    },
    updateActive(item, e) {
      if (e && e.target) {
        const activeElement = document.querySelector(
          ".mw-announcement-list button.active"
        );
        if (activeElement) activeElement.classList.remove("active");
        e.target.classList.add("active");
      }
      this.active = item;
    },
  },
};
</script>

<style>
:root {
  --announcementwidth: calc(calc(100% - calc(15px * 4)) / 5);
}
#mw-announcement-list-container {
  margin-top: -32px;
  z-index: 9;
  position: relative;
}
.mw-announcement-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 15px;
}
.mw-announcement-list button {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid white;
  width: var(--announcementwidth);
  height: 150px;
  margin: 0 15px 15px 0;
}
.mw-announcement-list button:last-child {
  margin: 0;
}
.mw-announcement-list button.active {
  border: 3px solid white;
}
.mw-announcement-active {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mw-announcement-content-container {
  margin-left: -50px;
  flex-basis: 650px;
  display: flex;
  flex-direction: column;
}
.mw-announcement-content-container a.content-link {
  margin-bottom: 0 !important;
  align-self: start;
  text-transform: uppercase;
}
.mw-announcement-content-container a.content-link:hover {
  color: #feed5a;
  text-decoration: underline;
}
.mw-announcement-content {
  color: white;
  max-height: 220px;
}
.mw-announcement-content h3 {
  margin: 0;
  margin-bottom: 12px;
}
.mw-announcement-content div.html-content {
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical !important;
  overflow: hidden;
}
.mw-announcement-content > div p {
  margin: 0;
}
.mw-announcement-image {
  width: calc(calc(2 * var(--announcementwidth)) + 15px);
  height: 357.38px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border: 1px solid white;
}
.announcement-mobile-controls {
  display: none;
  width: 100%;
  text-align: center;
}
.announcement-mobile-controls button {
  position: relative;
  width: 30px;
  height: 30px;
  background-color: #1fbec7 !important;
  padding: 0;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/js/vue-components/announcements/announcements-list.vue